module.exports = __webpack_public_path__ + "media/images/iconPlus__inactive--dark-7431348c630e40c26834f5734cef75b2.png";